export default "/images/messenger.svg?bd7dc2399efbe983cfc0b6c2054186fa";